import {Fragment, ReactNode, useEffect} from "react";
import {useDispatch} from "react-redux";
import {getZendeskUserFields, setInsideZendesk} from "./ZendeskSlice";

interface ZendeskProps {
  children: ReactNode;
}

const Zendesk = (props: ZendeskProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!window.initedZAFClient) {
      dispatch(setInsideZendesk(false));
    }

    dispatch(getZendeskUserFields());
    // Deps were missing entirely: this fetch re-fired on every re-render, and React 18
    // StrictMode double-invokes mount effects — run it once per mount instead.
  }, [dispatch]);
  return <Fragment>{props.children}</Fragment>;
};

export default Zendesk;
